export const SEARCH_PART_REQUEST = 'SEARCH_PART_REQUEST';
export const SEARCH_PART_SUCCESS = 'SEARCH_PART_SUCCESS';
export const SEARCH_PART_FAILURE = 'SEARCH_PART_FAILURE';

export const ADD_PART_REQUEST = 'ADD_PART_REQUEST';
export const ADD_PART_SUCCESS = 'ADD_PART_SUCCESS';
export const ADD_PART_FAILURE = 'ADD_PART_FAILURE';

export const ADD_SUPERSEDED_PART = 'ADD_SUPERSEDED_PART';
export const SUCCESSFULLY_ADDED_SUPERSEDED_PART = 'SUCCESSFULLY_ADDED_SUPERSEDED_PART';

export const GET_LOGISTICS_DATES_REQUEST = 'GET_LOGISTICS_DATES_REQUEST';
export const GET_LOGISTICS_DATES_SUCCESS = 'GET_LOGISTICS_DATES_SUCCESS';
export const GET_LOGISTICS_DATES_FAILURE = 'GET_LOGISTICS_DATES_FAILURE';

export const UPDATE_URGENCY = 'UPDATE_URGENCY';
export const UPDATE_CONSOLIDATION = 'UPDATE_CONSOLIDATION';
